import { useEffect, useState } from 'react';
import Seo from '@/components/Seo';
import { getBlogPosts } from '@/lib/api';
import { BlogCard } from '@/components/blog/BlogCard';
import { Skeleton } from '@/components/ui/skeleton';
import { BLOG } from '@/constants/testIds';

export default function BlogListPage() {
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        getBlogPosts()
            .then(setPosts)
            .catch(() => setPosts([]));
    }, []);

    return (
        <>
            <Seo
                title="Blog — digital productivity, quietly"
                description="Short, opinionated guides on file conversion, image optimization, web performance and getting more done with less friction."
                canonical="/blog"
            />
            <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-6">
                <p className="text-sm text-slate-500">The UtilityTool blog</p>
                <h1 className="mt-1 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Short guides. Real answers. No fluff.
                </h1>
                <p className="mt-2 text-slate-600 max-w-2xl">
                    We write about the small daily wins: better file workflows, faster
                    websites, smarter image handling.
                </p>
            </section>
            <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
                {posts === null ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[0, 1, 2, 3].map((i) => (
                            <div key={i} className="space-y-3">
                                <Skeleton className="aspect-[16/9] w-full rounded-xl" />
                                <Skeleton className="h-5 w-2/3" />
                                <Skeleton className="h-4 w-1/2" />
                            </div>
                        ))}
                    </div>
                ) : posts.length === 0 ? (
                    <p className="text-slate-600">No posts yet. Check back soon.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid={BLOG.listGrid}>
                        {posts.map((p) => (
                            <BlogCard key={p.slug} post={p} />
                        ))}
                    </div>
                )}
            </section>
        </>
    );
}
